<template>
  <v-container class="container-card">
    <v-card>
      <Equipes />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Equipes from "@/components/comissao/realizados/equipes/Equipes";
export default {
  components: {
    Equipes
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Realizado Equipe");
  }
};
</script>

<style></style>
